/* eslint-disable @typescript-eslint/naming-convention */
import { JsonReply, NextLocator, Partaker } from '@grupo-constant/next-dtype/types';
import { CompanyUser } from '../../../core/user/companyUser.model';
import { LocaleString } from '../../../core/translate/localeString.model';

// BRANDS
export const adminBrandProfileUri = 'userprofile://com.cloudcodice.thirdparty.grupoconstant.privileges.profile.UserProfileMasterMarca';

// CUSTOMER
export const adminCustomerProfileUri = 'userprofile://com.cloudcodice.thirdparty.grupoconstant.privileges.profile.UserProfileMasterClienteProyecto';
export const backofficeCustomerProfileUri = 'userprofile://com.cloudcodice.thirdparty.grupoconstant.privileges.profile.UserProfileBackoffice';
// PROJETS
export const adminProjectProfileUri = 'userprofile://com.cloudcodice.thirdparty.grupoconstant.privileges.profile.UserProfileMasterClienteProyecto';
export const backofficeProjectProfileUri = 'userprofile://com.cloudcodice.thirdparty.grupoconstant.privileges.profile.UserProfileBackoffice';
export const viewerProjectProfileUri = 'userprofile://com.cloudcodice.thirdparty.grupoconstant.privileges.profile.UserProfileViewer';
export interface NextBrand {
    busBrand?: BusBrand;
    marca_code?: string;
    marca_name?: string;
    name?: string;
    marca_lvl1_code?: string;
    marca_lvl1_name?: string;
    enabled?: boolean;
    premisesManagement?: boolean;
    from?: string;
    userId?: string;
    icon?: string;
    logo?: string;
    darkLogo?: string;
    role?: UserProfileMasterMarca;
    admin?: UserProfile[];
    active?: boolean;
    [adminBrandProfileUri]?: CompanyUser[] | string[] | UserProfile[];

    // Partaker info.
    brand?: NextBrand;
    customer?: NextCustomer;
    project?: NextProject;
}

export interface BrandsReply {
    nextMarca?: NextBrand[];
    size?: number;
    partaker?: Partaker;
}

export interface BrandReply {
    nextMarca?: NextBrand;
    partaker?: Partaker;
}

export interface FlushBrandReply extends JsonReply {
    nextMarca: NextBrand;
}

export interface BusBrand {
    marca_code?: string;
    marca_name?: string;
    marca_lvl1_code?: string;
    marca_lvl1_name?: string;
    busm_tms_alta?: string;
    busm_tms_modificacion?: string;
    isNext?: boolean;
}

export interface UserProfile {
    active?: boolean;
    cn?: string;
    displayName?: string;
    userId?: string;
    sAMAccountName?: string;
    marca_code?: string;
    grantor?: string;
    grantorName?: string;
    grantTimestamp?: string;
    userDatatypeUri?: string;
    payload?: any;
    profileImage?: string;
    userPrincipalName?: string;
    telephoneNumber?: string;
}

export interface UserProfilePayload {
    userId?: string;
    payload?: any;
    action?: UserProfilePayloadAction;
}

export enum UserProfilePayloadAction {
    REVOKE = 'REVOKE',
    RESET = 'RESET',
    FLUSH = 'FLUSH'
}

export interface UserProfileRole {
    admin?: UserProfileAdmin;
    designer?: UserProfileDesigner;
    planner?: UserProfilePlanner;
    developer?: any;
    superuser?: any;
}

export interface UserProfileAdmin {
    adminOU: boolean; // Administra tipos de la OU
    adminPwdMissionUsers: boolean; // Gestionar contraseñas del usuario de misión
    blockMissionUsers: boolean; // Bloquear usuarios de misión
    blockStructureUsers: boolean; // Bloquear usuarios de estructura
    consoleOperator: boolean; // Es operador de la consola de cloudcodice
    dataVerifier?: boolean;
    designer: boolean; // Actúa como un diseñador
    linkMarca?: boolean; // Enlazar nueva marca
    planner: boolean; // Actúa como un planificador
    profileAdminAdmin: boolean; // Administrar perfiles de administrador (incluido su perfil)
    supersedeOnBackoffice: boolean; // Suplantar a otros usuarios en Next Backoffice
    supersedeOnMobile: boolean; // Suplantar a otros usuarios en Next Mobile
}

export interface UserProfileDesigner {
    complexFacadeDesign: boolean; // Diseño de tipos agregados
    formFacadeDesign: boolean; // Diseño de cuestionarios
    launchService: boolean; // Iniciar un servicio
    linkCustomer?: boolean; // Enlazar nuevo cliente
    liveServiceAdmin: boolean; // Modificar el servicio en ejecución
    masterFacadeDesign: boolean; // Diseño de maestros
    nonLogicalMasterDeletion: boolean; // Borrado físico de filas de maestro
    planner: boolean; // Es planificador
    profileDesignerAdmin: boolean; // Administrar perfiles de diseñador (incluido su perfil)
    profilePlannerAdmin: boolean; // Administrar perfiles de planificador
    projectCreator?: boolean; // Crear nuevo proyecto
    serviceCreator?: boolean; // Crear nuevo servicio
    taskDeletion?: boolean; // Eliminar tareas completamente de la tabla
    tasktypeDesign: boolean; // Diseño de tipos de tarea
}

export interface UserProfilePlanner {
    launchService: boolean; // Iniciar un servicio
    resourceCreator: boolean; // Crear recursos sin nombre
}

export interface NextCustomer {
    marca_code?: string;
    cliente_code?: number;
    next_cliente_key?: string;
    cif?: string;
    name?: string;
    enabled?: boolean;
    from?: string;
    userId?: string;
    datatypeUri?: string;
    payload?: any;
    active?: boolean;
    logo?: string;
    darkLogo?: string;
    prefix?: string;
    role?: UserNodePrivileges;
    admin?: UserProfile[];
    backoffice?: UserProfile[];
    [adminCustomerProfileUri]?: CompanyUser[] | string[] | UserProfile[];
    [backofficeCustomerProfileUri]?: CompanyUser[] | string[] | UserProfile[];
    busCustomer?: BusCustomer;

    // Partaker info.
    brand?: NextBrand;
    customer?: NextCustomer;
    project?: NextProject;
}

export interface CustomersReply {
    nextCliente?: NextCustomer[];
    size?: number;
    partaker?: Partaker;
}

export interface CustomerReply {
    nextCliente?: NextCustomer;
    partaker?: Partaker;
}

export interface FlushCustomerReply extends JsonReply {
    nextCliente: NextCustomer;
}

export interface BusCustomer {
    clcifdni?: string;
    displayName?: string;
    clnombre?: string;
    clcodigo?: number;
    isNext?: boolean;
}

export interface NextProject {
    projectId?: string;
    marca_code?: string;
    cliente_code?: number;
    name?: string;
    enabled?: boolean;
    from?: string;
    userId?: string;
    datatypeUri?: string;
    payload?: any;
    active?: boolean;
    logo?: string;
    darkLogo?: string;
    prefix?: string;
    role?: UserNodePrivileges;
    admin?: UserProfile[];
    backoffice?: UserProfile[];
    viewer?: UserProfile[];
    [adminProjectProfileUri]?: CompanyUser[] | string[] | UserProfile[];
    [backofficeProjectProfileUri]?: CompanyUser[] | string[] | UserProfile[];
    [viewerProjectProfileUri]?: CompanyUser[] | string[] | UserProfile[];
    next_cliente_key?: string;

    // Partaker info.
    brand?: NextBrand;
    customer?: NextCustomer;
    project?: NextProject;
}

export interface ProjectsReply {
    nextProyecto?: NextProject[];
    size?: number;
    partaker?: Partaker;
}

export interface ProjectReply {
    nextProyecto?: NextProject;
    partaker?: Partaker;
}

export interface FlushProjectReply extends JsonReply {
    nextProyecto: NextProject;
}

export interface ConfirmChanges {
    hasChanges: boolean;
}

export interface MissionInfo {
    projectId: string;
    serviceId: string;
    title: string;
    summary: LocaleString;
    body: LocaleString;
    image: string[];
    file: string[];
    showPlannerInfo: boolean;
    showServiceDates: boolean;
    userId: string;
    lastTimestamp: string;
}

export interface UserNodePrivilegesInterface {
    userId: string;
    sAMAccountName: string;
    ou: string;
    marca_code?: string;
    cliente_code?: number;
    projectId?: string;
    serviceId?: string;
    grantor: string;
    grantTimestamp: string;
    userDatatypeUri: string;
}

export interface UserNodePrivileges extends UserNodePrivilegesInterface {
    systemConfig?: boolean;	//OU	developer
    supersedeOnBackoffice?: boolean;	//OU	developer
    reloadLinkedData?: boolean;	//OU	superuser
    blockBackofficeUsers?: boolean;	//OU	superuser
    nonLogicalMasterDeletion?: boolean;	//OU, MCPS	master
    adminProfile?: boolean;	//OU, MCPS	master
    dataVerifier?: boolean;	//OU, M	master
    adminMeAndChildren?: boolean;	//OU, MCPS	backoffice
    blockMobileUsers?: boolean;	//OU, MCPS	backoffice
    supersedeOnMobile?: boolean;	//OU, MCPS	backoffice
    masterDataDesigner?: boolean;	//OU, MCPS	backoffice
    masterDataManagement?: boolean;	//OU, MCPS	backoffice
    formDesigner?: boolean;	//OU, MCPS	backoffice
    taskTypeDesigner?: boolean;	//OU, MCPS	backoffice
    adminMobileUser?: boolean;	//OU, MCPS	backoffice
    ejectMobileUser?: boolean;	//OU, MCPS	backoffice
    adminTask?: boolean;	//OU, MCPS	backoffice
    taskDeletion?: boolean;	//OU, MCPS	backoffice
    alterTask?: boolean;	//OU, MCPS	backoffice
    viewTask?: boolean;	//OU, MCPS	viewer
    absenceReviewer?: boolean; //superuser developer MCPS backoffice
    calendarManagement?: boolean; //superuser developer MCPS backoffice
    presenceManagement?: boolean; //superuser developer MCPS backoffice
    payrollValidator?: boolean; //superuser developer MCPS backoffice
    send2ConnectCore?: boolean; //superuser developer M
}

export interface UserProfileSuperuser extends UserNodePrivilegesInterface {
    blockBackofficeUsers: boolean;
    nonLogicalMasterDeletion: boolean;
    adminProfile: boolean;
    dataVerifier: boolean;
    adminMeAndChildren: boolean;
    blockMobileUsers: boolean;
    supersedeOnMobile: boolean;
    masterDataDesigner: boolean;
    masterDataManagement: boolean;
    formDesigner: boolean;
    taskTypeDesigner: boolean;
    adminMobileUser: boolean;
    ejectMobileUser: boolean;
    adminTask: boolean;
    taskDeletion: boolean;
    alterTask: boolean;
    viewTask: boolean;
}

export interface UserProfileDeveloper extends UserNodePrivilegesInterface {
    systemConfig: boolean;
    supersedeOnBackoffice: boolean;
    blockBackofficeUsers: boolean;
    nonLogicalMasterDeletion: boolean;
    adminProfile: boolean;
    dataVerifier: boolean;
    adminMeAndChildren: boolean;
    blockMobileUsers: boolean;
    supersedeOnMobile: boolean;
    masterDataDesigner: boolean;
    masterDataManagement: boolean;
    formDesigner: boolean;
    taskTypeDesigner: boolean;
    adminMobileUser: boolean;
    ejectMobileUser: boolean;
    adminTask: boolean;
    taskDeletion: boolean;
    alterTask: boolean;
    viewTask: boolean;
}

export interface UserProfileMasterMarca extends UserNodePrivilegesInterface {
    nonLogicalMasterDeletion: boolean;
    adminProfile: boolean;
    dataVerifier: boolean;
    adminMeAndChildren: boolean;
    blockMobileUsers: boolean;
    supersedeOnMobile: boolean;
    masterDataDesigner: boolean;
    masterDataManagement: boolean;
    formDesigner: boolean;
    taskTypeDesigner: boolean;
    adminMobileUser: boolean;
    ejectMobileUser: boolean;
    adminTask: boolean;
    taskDeletion: boolean;
    alterTask: boolean;
    viewTask: boolean;
}

export interface UserProfileMasterClienteProyecto extends UserNodePrivilegesInterface {
    nonLogicalMasterDeletion: boolean;
    adminProfile: boolean;
    adminMeAndChildren: boolean;
    blockMobileUsers: boolean;
    supersedeOnMobile: boolean;
    masterDataDesigner: boolean;
    masterDataManagement: boolean;
    formDesigner: boolean;
    taskTypeDesigner: boolean;
    adminMobileUser: boolean;
    ejectMobileUser: boolean;
    adminTask: boolean;
    taskDeletion: boolean;
    alterTask: boolean;
    viewTask: boolean;
}

export interface UserProfileBackoffice extends UserNodePrivilegesInterface {
    adminMeAndChildren: boolean;
    blockMobileUsers: boolean;
    supersedeOnMobile: boolean;
    masterDataDesigner: boolean;
    masterDataManagement: boolean;
    formDesigner: boolean;
    taskTypeDesigner: boolean;
    adminMobileUser: boolean;
    ejectMobileUser: boolean;
    adminTask: boolean;
    taskDeletion: boolean;
    alterTask: boolean;
    viewTask: boolean;
}

export interface UserProfileViewer extends UserNodePrivilegesInterface {
    viewTask: boolean;
}

export interface RetrieveNextServicioMissionInfoBody {
    projectId: string;
}
export interface RetrieveNextServicioMissionInfoReply extends JsonReply {
    missionInfo: MissionInfo;
}

export interface FlushNextServicioMissionInfoBody {
    projectId: string;
    serviceId: string;
    title: string;
    summary: LocaleString;
    body: LocaleString;
    image: string[];
    file: string[];
    showPlannerInfo: boolean;
    showServiceDates: boolean;
    userId: string;
    lastTimestamp: string;
}
export interface FlushNextServicioMissionInfoReply extends JsonReply {
    missionInfo: MissionInfo;
}
export interface DeleteNextServicioMissionInfoReply {
    status: string;
}

export interface RetrieveVisibilityMapReply {
    visibilityMap: {
        [uri: string]: {
            [key: string]: boolean;
        }
    };
    partaker: Partaker;
}

export interface NextCalendar {
    _oid: string;
    _deprecated: boolean;
    belongsTo: string;
    belongsToDN: string;
    belongsToCaption: string;
    name: string;
    sameLocator: boolean;
    syncOid: string;
    weekDays: string[];
}

export interface RetrieveCalendarWithDNRequest {
    locator: NextLocator;
}

export interface RetrieveCalendarWithDNReply extends JsonReply {
    collection: NextCalendar[];
    partaker: Partaker;
}

export interface RetrieveCalendarDateListRequest {
    calendarOid: string;
}

export interface retrieveCalendarDateListReply extends JsonReply {
    dates: {
        calendarOid: string;
        holidayTypeOid: string;
        holiday: string;
        holidayName: string;
    }[];
}

export interface FlushCalendarRequest {
    locator: NextLocator;
    calendar: Partial<NextCalendar>;
    calendarDates: string[];
}

export interface FlushCalendarReply extends JsonReply {
    calendar: NextCalendar;
    partaker: Partaker;
}
